import { useState, useEffect } from "react";
import { BgModal, BoxModal } from './styles'

import { AddDia, Edit, EditSimb, EditSelo, EditSimbCor, ChangePositionCiclo, Assine, AddRegra, EditRegra, EditRegraDia} from '../Forms';

interface iModal {
    show: boolean,
    datamodal: any,
    setShowmodal: any,
    setUpdateciclo?: any
}

export default function Modal({show, datamodal, setShowmodal, setUpdateciclo}: iModal) {

    const [open, setOpen] = useState(show);
    const [data, setData] = useState(datamodal);
    useEffect(() => {        
        setOpen(show);
    }, [show]);

    useEffect(() => {      
        setData(datamodal);
    }, [datamodal]);
  
    return (
        <BgModal show={open}>
            {open && (
            <BoxModal>
                <div className="topo">
                    <span>{data.title}</span>
                    <button className="close" onClick={() => setShowmodal(false)}><span className="material-icons">close</span></button>
                </div>
                <div className="content">
                    {datamodal.component === 'add' && (
                        <AddDia data={data} setShowmodal={(e: boolean) => setShowmodal(e)} setUpdateciclo={(e:boolean) => setUpdateciclo(e)} />
                    )}
                    {datamodal.component === 'edit' && (
                        <Edit data={data} setShowmodal={(e: boolean) => setShowmodal(e)} setUpdateciclo={(e:boolean) => setUpdateciclo(e)} />
                    )}
                    {datamodal.component === 'editsimb' && (
                        <EditSimb data={data} setShowmodal={(e: boolean) => setShowmodal(e)} setUpdateciclo={(e:boolean) => setUpdateciclo(e)} />
                    )}
                    {datamodal.component === 'editselo' && (
                        <EditSelo data={data} setShowmodal={(e: boolean) => setShowmodal(e)} setUpdateciclo={(e:boolean) => setUpdateciclo(e)} />
                    )}
                    {datamodal.component === 'changeposciclo' && (
                        <ChangePositionCiclo data={data} setShowmodal={(e: boolean) => setShowmodal(e)} setUpdateciclo={(e:boolean) => setUpdateciclo(e)} />
                    )}
                    {datamodal.component === 'assine' && (
                        <Assine setShowmodal={(e: boolean) => setShowmodal(e)} />
                    )}
                    {datamodal.component === 'addregra' && (
                        <AddRegra data={data} setShowmodal={(e: boolean) => setShowmodal(e)} />
                    )}
                    {datamodal.component === 'editregra' && (
                        <EditRegra data={data} setShowmodal={(e: boolean) => setShowmodal(e)} />
                    )}
                    {datamodal.component === 'editsimbcor' && (
                        <EditSimbCor data={data} setShowmodal={(e: boolean) => setShowmodal(e)} setUpdateciclo={(e:boolean) => setUpdateciclo(e)} />
                    )}
                    {datamodal.component === 'editregradia' && (
                        <EditRegraDia data={data} setShowmodal={(e: boolean) => setShowmodal(e)} setUpdateciclo={(e:boolean) => setUpdateciclo(e)} />
                    )}
                </div>
            </BoxModal>
            )}
        </BgModal>
    )
  }